export const SCHOOL_IDENTIFIER_STUDENT_CARD_ID = 'student-card-id';
export const SCHOOL_IDENTIFIER_SSN = 'ssn';

export const PLAN_COVERAGE_STUDENT = "1";
export const PLAN_COVERAGE_STUDENT_AND_SPOUSE = "2";
export const PLAN_COVERAGE_STUDENT_AND_CHILDREN = "3";
export const PLAN_COVERAGE_STUDENT_AND_FAMILY = "4";
export const PLAN_COVERAGE_STUDENT_PLUS_ONE = "5";

export const PLAN_LENGTH_6_MONTHS = 1;
export const PLAN_LENGTH_12_MONTHS = 1;

export const DEPENDENT_RELATION_SPOUSE = 2;
export const DEPENDENT_RELATION_CHILD = 3;

export const DEPENDENT_TEMPLATE = {
    first_name: "",
    middle_name: "",
    last_name: "",
    facility: "",
    birthdate: null,
    spouse: false
};

export const COVERAGE_CODE_CUSTOM_ORDER = ['1', '5', '2', '3', '4'];
